// Sprint 8.1 — Hook de check de permission par feature.
//
// Usage :
//   const canCreateOp = usePermission('caisse.create_op');
//   if (!canCreateOp) return null;
//
// Logique :
//   - admin (super_admin / direction) → toujours true
//   - permissions === null/undefined → true (rétro-compat avec users existants)
//   - permissions = {} ou whitelist → true UNIQUEMENT si key === true
//
// La whitelist est éditée depuis Paramètres > Utilisateurs > [user] > Permissions.

import { useUser } from '@/hooks/useUser';
import { hasPermission, type FeatureKey } from '@/lib/permissions';

export function usePermission(key: FeatureKey): boolean {
  const { metadata } = useUser();
  const isAdmin = metadata?.role === 'super_admin' || metadata?.role === 'direction';
  const permissions =
    (metadata as unknown as { permissions?: Record<string, boolean> | null } | null)?.permissions ??
    null;
  return hasPermission(permissions, key, isAdmin);
}
